import React from 'react'

import { H1, Button } from '../Common'

import style from './SignupFacebook.scss'

import disappointed from '../../images/emojis/disappointed.svg'

export default function() {
  return (
    <div className={style.wrapper}>
      <img src={disappointed} alt="Ahhh!" />
      <H1>ops!</H1>
      <p>Você precisa autorizar o aplicativo dentro do Facebook para continuar o cadastro.</p>
      <Button href="/facebook_login" title="Conecte-se pelo Facebook" tabIndex={0} autoFocus xl>
        tentar novamente
      </Button>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Pages/SignupFacebookUnauthorized.js